import { useEffect, useState } from 'react';
import Icon from './Icon';
import { useLanguage } from '../i18n/language';
import { useT } from '../i18n/translations';
import { fetchSuperAdminContactMessages, updateSuperAdminContactMessageRead } from '../superAdminContactMessagesApi';
import './BranchesPage.css';
import './UsersPage.css';

export default function SuperAdminContactMessagesPage() {
  const { language, direction } = useLanguage();
  const t = useT();
  const dateLocale = (language === 'ar' || language === 'ur') ? 'ar-SA' : 'en-US';

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const list = await fetchSuperAdminContactMessages();
        if (!cancelled) setRows(list);
      } catch (e) {
        if (!cancelled) setError(e instanceof Error ? e.message : t('superAdmin.loadFailed'));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleRead = async (row) => {
    try {
      const updated = await updateSuperAdminContactMessageRead(row.id, !row.isRead);
      setRows((prev) => prev.map((x) => (x.id === row.id ? updated : x)));
    } catch (e) {
      setError(e instanceof Error ? e.message : t('superAdmin.loadFailed'));
    }
  };

  return (
    <div className="page users-page" dir={direction}>
      <div className="list-page-card list-page-card--unified">
        <header className="list-page-card__header">
          <div className="list-page-card__titles">
            <span className="list-page-card__title"><Icon name="chat" size={18} color="#00334a" style={{ verticalAlign: 'middle', marginLeft: 6 }} />{t('superAdmin.contactMsgs')}</span>
            <span className="list-page-card__sub">{t('superAdmin.contactSub')}</span>
          </div>
        </header>

        {error && <div className="list-page-card__banner list-page-card__banner--error">{error}</div>}
        {loading && <div className="list-page-card__loading">{t('superAdmin.loading')}</div>}

        {!loading && (
        <div className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ width: 42 }}>#</th>
                <th>{t('superAdmin.sender')}</th>
                <th>{t('superAdmin.colSubject')}</th>
                <th>{t('superAdmin.message')}</th>
                <th>{t('superAdmin.colDate')}</th>
                <th>{t('superAdmin.colStatus')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={row.id}>
                  <td className="td-num">{idx + 1}</td>
                  <td>
                    <div className="users-user-cell">
                      <div className="users-avatar">{(row.senderName || '?').charAt(0)}</div>
                      <div>
                        <div className="users-name">{row.senderName}</div>
                        <div className="users-email">{row.senderEmail}{row.senderPhone ? ` · ${row.senderPhone}` : ''}</div>
                      </div>
                    </div>
                  </td>
                  <td>{row.subject}</td>
                  <td style={{ maxWidth: 420, whiteSpace: 'pre-wrap' }}>{row.message}</td>
                  <td>{row.createdAtUtc ? new Date(row.createdAtUtc).toLocaleString(dateLocale) : ''}</td>
                  <td>
                    <button type="button" className="btn btn--ghost" onClick={() => toggleRead(row)}>
                      <Icon name={row.isRead ? 'check-circle' : 'warning'} size={13} />
                      {row.isRead ? t('superAdmin.markUnread') : t('superAdmin.markRead')}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!rows.length && <div className="users-empty">{t('superAdmin.noMessages')}</div>}
        </div>
      )}
      </div>
    </div>
  );
}
